import { capitalize } from "lodash";
import moment from "moment";
import { useContext, useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { PageContainerContext, UserContext } from "../../Provider";
import AGButton from "../../components/Button";
import Card from "../../components/Card";
import AddProductModal from "../../components/ModalAddProduct";
import AddSecondmentModal from "../../components/ModalAddScondment";
import AddServiceModal from "../../components/ModalAddService";
import UpdateProductModal from "../../components/ModalUpdateProduct";
import UpdateSecondmentModal from "../../components/ModalUpdateSecondment";
import UpdateServiceModal from "../../components/ModalUpdateService";
import { useNotification } from "../../components/Notification";
import { isRolesVendor, RolesHandle, RolesHandleAdmin, RolesHandleInquiries, RolesVendor } from "../../components/RolesHandle";
import { CompleteCreateServiceModal } from "../../components/completeCreateService";
import { useNavigateWithSearchParams } from "../../hook/navigate";
import { useUserMappingAdminRoles, useUserMappingRoles } from "../../hook/useUserMappingRoles";
import {
    CommerceFirmData,
    CommerceFirmDetailRES,
    FirmProfile,
} from "../../models";
import { httpDELETE, httpGET, httpPOST, httpPUT } from "../../utils/ajaxHelper";
import { ADMIN_ORGANIZATION, API_CONSTANT, INTEREST_TYPE, KEY_ITEM_LOCALSTORAGE, ORGANIZATION_TYPE } from "../../utils/constant";
import { getPathAndQuery } from "../../utils/handleUrl";
import { formatDate, handleStatusMessage } from "../../utils/helper";
import { MESSAGE_TOOLTIP } from "../../utils/messages";
import FormMessageModal from "../searchServices/formMessageModal";
import RegionContactFormMessageModal from "../searchServices/formMessageRegionModal";
import DescriptionModal from "./DescriptionModal";
import AddBrochureModal from "./addBrochureModal";
import AddContactModal from "./addContactModal";
import AddDescriptionModal from "./addDescriptionModal";
import AddVideoModal from "./addVideoModal";
import ApproveConfirmModal from "./approveModal";
import BrochureItem from "./brochureItem";
import ServiceBrochureItem from "./brochureItem/serviceBrochure";
import AddHeaderdModal from "./cardFirmHeader";
import CardItem from "./cardItem";
import {
    Container,
    Div,
    FirmAddDesciption,
    FirmBackGound,
    FirmContactBrochureAttach,
    InfomationLookGood,
    Logo,
    PenIconStyled,
    ProductList,
    ProfileContainer,
    RejectMessage,
    ServiceList,
    TagSponsorService,
    TagVendor
} from "./commerce.styled";
import ContactModal from "./contactModal";
import { InquiriesIcon } from "../../components/Header";
import RegionContactsModal from "./contactModal/regionContact";
import ServiceContactsModal from "./contactModal/serviceContact";
import DeleteConfirmModal from "./deleteConfirmModal/deleteConfirmModal";
import DistAreaModal from "./distAreaModal";
import FirmAvailabilityModal from "./firmAvailabilityModal";
import IndustryNichesModal from "./industryNiches";
import MemberBenefitModal from "./memberBenefitModal";
import ProductItems from "./productItems";
import SecondmentItems from "./productItems/secondment";
import RejectConfirmModal from "./rejectOfferingModal";
import SecondmentInterestTypes from "./secondmentInterestTypes";
import ServiceDescriptionModal from "./serviceDetailModal";
import ServiceLogoModal from "./serviceLogoModal";
import ThumbnailContainer from "./thumbnailContainer";
import ProductsThumbnailContainer from "./thumbnailContainer/productContainer";
import SecondmentsThumbnailContainer from "./thumbnailContainer/secondmentContainer";
import VideoModal from "./videoModal";
import ServiceVideoModal from "./videoModal/serviceVideo";
import FirmSecondmentContactModal from "./contactModal/firmSeconmentContact";
import AddSecondmentContactModal from "./addContactModal/addSecondmentContact";

const apiDomain = process.env.REACT_APP_API_DOMAIN;

const CommerceProfile = () => {
    const { id: firmId } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [showModal, setShowModal] = useState<string | undefined>();
    const [showSecondModal, setShowSecondModal] = useState<string | undefined>();
    const [, setShowThankModal] = useState<boolean>(false);
    const [firmProfileData, setFirmProfile] = useState<FirmProfile>();
    const [selectedSecondServ,] = useState();
    const [serviceData, setServiceData] = useState<CommerceFirmData[]>();
    const [productsData, setProductsData] = useState<CommerceFirmData[]>();
    const [secondmentsData, setSecondmentsData] = useState<CommerceFirmData[]>();
    const [secondmentsSeekingData, setSecondmentsSeekingData] = useState<CommerceFirmData[]>();
    const [createdOfferings, setCreatedOfferings] = useState<number>();
    // const CurrentPage = searchParams.get("location") ?? "firmProfile";
    const tab =
        searchParams.get("tab") === ""
            ? undefined
            : searchParams.get("tab");

    const [serviceDetail, setServiceDetail] = useState<
        CommerceFirmDetailRES | undefined
    >();
    const [handleNavigate] = useNavigateWithSearchParams();
    const serviceId =
        searchParams.get("serviceId") === ""
            ? undefined
            : searchParams.get("serviceId");
    const location = useLocation();
    const today = moment();
    const navigate = useNavigate();
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const isMobileScreen = screenHeight < 430;
    const isMobileScreenPage = screenWidth < 769;
    const user = useContext(UserContext);
    const [, rolesAndPermissionByFirm] = useUserMappingRoles();
    const [, rolesAndPermissionAdmin] = useUserMappingAdminRoles();
    const [selectedRegion, setSelectedRegion] = useState<number | undefined>(undefined);
    const [showModalAddService, setShowModalAddService] = useState<boolean>(false);
    const [showModalAddProduct, setShowModalAddProduct] = useState<boolean>(false);
    const [showModalAddSecondment, setShowModalAddSecondment] = useState<boolean>(false);
    const [showModalThank, setShowModalThank] = useState<boolean>(false);
    const profileRef = useRef<HTMLDivElement | null>(null);
    const { showNotification } = useNotification();
    const [firstViewProfile, setFirstViewProfile] = useState<boolean>(true);
    const pageContainerDivRef = useContext(PageContainerContext)

    const { mutate: getFirmProfile } = useMutation(
        () =>
            httpGET({
                url: `/FirmProfile/${firmId}`,
                params: { firmId: firmId },
            }),
        {
            onSuccess: (rs) => {
                setFirmProfile(rs as FirmProfile);
            },
            onError: (rs: any) => {
                navigate("/404");
            }
        },
    );

    const { mutate: getSelectedServ } = useMutation(
        (data: any) =>
            httpGET({
                url: `/FirmProfile/serviceDetail/${firmId}`,
            }),
        {
            onSuccess: (rs) => {
                setServiceData(rs.firmDatas as CommerceFirmData[]);
            },
        },
    );

    const { mutate: getProducts } = useMutation(
        (data: any) =>
            httpGET({
                url: `/FirmProfile/products/${firmId}`,
            }),
        {
            onSuccess: (rs) => {
                setProductsData(rs.firmDatas as CommerceFirmData[]);
            },
        },
    );

    const { mutate: getSecondments } = useMutation(
        ({ data, interestType }: any) =>
            httpGET({
                url: `/FirmProfile/secondments/${firmId}`,
                params: {
                    interestType: interestType
                }
            }),
        {
            onSuccess: (rs, { interestType }) => {

                if(user?.roles?.includes("VendorUser") && tab === "secondment"){
                    navigate("/404");
                }
                else{
                    interestType === INTEREST_TYPE.OFFERING && setSecondmentsData(rs.firmDatas as CommerceFirmData[]);
                    interestType === INTEREST_TYPE.SEEKING && setSecondmentsSeekingData(rs.firmDatas as CommerceFirmData[])
                    setCreatedOfferings(rs.createdOfferings);
                }
            },
        },
    );

    const { mutate: getServiceDetailData } = useMutation(
        (id: number) =>
            httpGET({
                url: `/Profile/${id}`
            }),
        {
            onSuccess: (rs: CommerceFirmDetailRES) => {
                if (rs.commerceFirmData?.isDelete) {
                    // navigate("/404");
                }
                setServiceDetail(rs);
            },
            onError: (rs: any) => {
                navigate("/404");
            }
        },
    );

    const { mutate: informationLookGood } = useMutation(
        () =>
            httpPUT({
                url: "/CommerceFirmData/" + serviceId,
            }),
        {
            onSuccess: (rs: CommerceFirmDetailRES) => {
                getServiceDetailData(Number(serviceId));
            },
        },
    );

    const { mutate: logViewFirmProfile } = useMutation(
        (id: string | undefined) =>
            httpPOST({
                url: `/FirmProfile`,
                params: { firmId: id },
            }),
    );

    const { mutate: logViewServiceProfile } = useMutation(
        (id: number | undefined) =>
            httpPOST({
                url: `/Profile`,
                params: { serviceId: id },
            }
            ),
    );

    const { mutate: deleteFirmService } = useMutation(
        () =>
            httpDELETE({
                url: "/CommerceFirmData/delete?id=" + serviceId,
            }),
        {
            onSuccess: (rs: CommerceFirmDetailRES) => {
                setShowSecondModal(undefined);
                setShowModal(undefined);
                handleNavigate(location.pathname, { serviceId: "" });
                getSelectedServ(selectedSecondServ);
                getProducts(selectedSecondServ);
                getAllSecondments(selectedSecondServ);
                setServiceDetail(undefined);
            },
            onError: (rs: any) => {
                setShowSecondModal(undefined);
                setShowModal(undefined);
                showNotification(rs.message, "Error");

                if (rs.message.includes("approval")) {
                    showNotification(rs.message, "Error");
                    getServiceDetailData(Number(serviceId));
                    getSelectedServ(selectedSecondServ ?? 1);
                }

                if (rs.message.includes("delete")) {
                    setSearchParams({ ...searchParams, tab: tab?.toString(), serviceId: "" });
                }
            }
        },
    );

    const getAllSecondments = (data: any) => {
        getSecondments({ data: data ?? selectedSecondServ, interestType: INTEREST_TYPE.OFFERING });
        getSecondments({ data: data ?? selectedSecondServ, interestType: INTEREST_TYPE.SEEKING });
    }

    const { mutate: approveOffering } = useMutation(
        () =>
            httpPUT({
                url: "/CommerceFirmData/approve/" + serviceId,
            }),
        {
            onSuccess: (rs: CommerceFirmDetailRES) => {
                setShowSecondModal(undefined);
                setShowModal(undefined);
                getServiceDetailData(Number(serviceId));
            },
            onError: (rs: any) => {
                showNotification(rs.message, "Error");
                if (rs.message.includes("delete")) {
                    setShowSecondModal(undefined);
                    setShowModal(undefined);
                    setSearchParams({ ...searchParams, tab: tab?.toString(), serviceId: "" });
                }
                else {
                    setShowSecondModal(undefined);
                    setShowModal(undefined);
                    getServiceDetailData(Number(serviceId));
                }
            }
        },

    );

    const { mutate: rejectOffering } = useMutation(
        (rejectReason: string) =>
            httpPUT({
                url: `/CommerceFirmData/reject/${serviceId}?rejectReason=${encodeURIComponent(rejectReason.trim())}`,
            }),
        {
            onSuccess: (rs: CommerceFirmDetailRES) => {
                setShowSecondModal(undefined);
                setShowModal(undefined);
                getServiceDetailData(Number(serviceId));
            },
            onError: (rs: any) => {
                showNotification(rs.message, "Error");
                if (rs.message.includes("delete")) {
                    setShowSecondModal(undefined);
                    setShowModal(undefined);
                    setSearchParams({ ...searchParams, tab: tab?.toString(), serviceId: "" });
                }
                else {
                    setShowSecondModal(undefined);
                    setShowModal(undefined);
                    getServiceDetailData(Number(serviceId));
                }
            }
        }
    );

    const handleDeleteParam = () => {
        // Get current parameters
        const params = new URLSearchParams(searchParams);

        // Delete a parameter
        params.delete('serviceId');

        // Set the updated search parameters back
        setSearchParams(params);
    };

    const showMemberBenefit = (firmData: FirmProfile, serviceData: CommerceFirmDetailRES) => {

        if (firmData?.orgType !== 1 && serviceData?.commerceFirmData!.fkOfferingTypeId === 1) {
            return true;
        }
        if (serviceData?.commerceFirmData!.fkOfferingTypeId === 2) {
            return true;
        }

        return false;
    }


    useEffect(() => {
        if (!serviceId || serviceId === "") {
            setServiceDetail(undefined);
            setProductsData(undefined);
        }
    }, [serviceId])

    useEffect(() => {
        getSelectedServ(selectedSecondServ);
        getProducts(selectedSecondServ);
        getAllSecondments(selectedSecondServ);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedSecondServ]);

    useEffect(() => {
        getFirmProfile();
        getSelectedServ(selectedSecondServ ?? 1);
        getProducts(selectedSecondServ ?? 1);
        getAllSecondments(selectedSecondServ ?? 1);
        if (!serviceId && user?.individual.fkOrgId !== Number(firmId) && firstViewProfile) {
            logViewFirmProfile(firmId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams, showModal, firmId]);

    useEffect(() => {
        if (serviceId) {
            getServiceDetailData(Number(serviceId));
        }
        if (serviceId && user?.individual.fkOrgId !== Number(firmId)) {
            logViewServiceProfile(Number(serviceId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams]);

    useEffect(() => {
        const handleResize = () => {
            setScreenHeight(window.innerHeight);
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        pageContainerDivRef?.current?.scrollTo({ top: 0, behavior: "auto" });
    }, [serviceId, pageContainerDivRef]);


    const handleTextByTab = (tab: string, type?: string) => {

        if (type === "delete") {
            switch (tab) {
                case "service":
                    return "Delete Service";
                case "product":
                    return "Delete Product";
                case "secondment":
                    return "Delete Secondment";
                default:
                    return "";
            }
        }
        else if (type === "update") {
            switch (tab) {
                case "service":
                    return "Edit Service";
                case "product":
                    return "Edit Product";
                case "secondment":
                    return "Edit Secondment";
                default:
                    return "";
            }
        }
        else {
            switch (tab) {
                case "service":
                    return "Service";
                case "product":
                    return "Product";
                case "secondment":
                    return "Secondment";
                default:
                    return "";
            }
        }
    };

    const handleStateByTab = (tab: string, type?: string) => {
        if (type === "update") {
            switch (tab) {
                case "service":
                    setShowModal("EditService");
                    return "services";
                case "product":
                    setShowModal("EditProduct");
                    return "products";
                case "secondment":
                    setShowModal("EditSecondment")
                    return "secondments";
                default:
                    setShowModal(undefined)
                    return "";
            }
        }
        else if (type === "delete") {
            switch (tab) {
                case "service":
                    setShowModal("DeleteService");
                    return "services";
                case "product":
                    setShowModal("DeleteProduct");
                    return "products";
                case "secondment":
                    setShowModal("DeleteSecondment")
                    return "secondments";
                default:
                    setShowModal(undefined)
                    return "";
            }
        }
        else {
            switch (tab) {
                case "service":
                    setShowModal("DeleteService");
                    return "services";
                case "product":
                    setShowModal("DeleteProduct");
                    return "products";
                case "secondment":
                    setShowModal("DeleteSecondment")
                    return "secondments";
                default:
                    setShowModal(undefined)
                    return "";
            }
        }
    }

    const isSponsorProfile = () =>{
        return serviceDetail?.sponsorProfile &&
        serviceDetail?.sponsorProfile === true &&
        moment(serviceDetail?.sponsorStartDate).isSameOrBefore(moment(), 'day')
    }

    return (
        <ProfileContainer isMobileScreen={isMobileScreenPage} ref={profileRef}>
            {serviceId && (
                <>
                    <UpdateServiceModal
                        publishComplete={() => {
                            setShowModal(undefined);
                            getServiceDetailData(Number(serviceId));
                            getSelectedServ(selectedSecondServ ?? 1);
                            setShowThankModal(true);
                        }}
                        visible={showModal === "EditService"}
                        toggleModal={() => {
                            setShowModal(undefined);
                            getServiceDetailData(Number(serviceId));
                            getSelectedServ(selectedSecondServ ?? 1);
                        }}
                        toggleError={() => {
                            setShowModal(undefined);
                            setServiceDetail(undefined);
                        }}
                        id={serviceId}
                        onDeleteService={(e) => {
                            e && setShowSecondModal("DeleteService")
                        }}
                        initSearchParams={searchParams}
                    />
                </>
            )}

            {serviceId && (
                <>
                    <UpdateProductModal
                        publishComplete={() => {
                            setShowModal(undefined);
                            getServiceDetailData(Number(serviceId));
                            getProducts(selectedSecondServ ?? 1);
                            setShowThankModal(true);
                        }}
                        visible={showModal === "EditProduct"}
                        toggleModal={() => {
                            setShowModal(undefined);
                            getServiceDetailData(Number(serviceId));
                            getProducts(selectedSecondServ ?? 1);
                        }}
                        toggleError={() => {
                            setShowModal(undefined);
                            setServiceDetail(undefined);
                        }}
                        id={serviceId}
                        onDeleteService={(e) => {
                            e && setShowSecondModal("DeleteProduct")
                        }}
                        initSearchParams={searchParams}
                    />
                </>
            )}


            {serviceId && (
                <>
                    <UpdateSecondmentModal
                        publishComplete={() => {
                            setShowModal(undefined);
                            getServiceDetailData(Number(serviceId));
                            getAllSecondments(selectedSecondServ ?? 1);
                            setShowThankModal(true);
                        }}
                        visible={showModal === "EditSecondment"}
                        toggleModal={() => {
                            setShowModal(undefined);
                            getServiceDetailData(Number(serviceId));
                            getAllSecondments(selectedSecondServ ?? 1);
                        }}
                        toggleError={() => {
                            setShowModal(undefined);
                            setServiceDetail(undefined);
                        }}
                        offeringId={serviceId}
                        onDeleteService={(e) => {
                            e && setShowSecondModal("DeleteSecondment")
                        }}
                        initSearchParams={searchParams}
                    />
                </>
            )}

            <DeleteConfirmModal
                deleteService={() => {
                    deleteFirmService();
                }}
                toggleModal={() => {
                    // if (tab === "service") {
                    //     showModal !== "EditService" ? setShowModal(undefined) : setShowSecondModal(undefined);
                    // } else {
                    //     showModal !== "EditProduct" ? setShowModal(undefined) : setShowSecondModal(undefined);
                    // }

                    switch (tab) {
                        case "service":
                            showModal !== "EditService" ? setShowModal(undefined) : setShowSecondModal(undefined);
                            break;
                        case "product":
                            showModal !== "EditProduct" ? setShowModal(undefined) : setShowSecondModal(undefined);
                            break;
                        case "secondment":
                            showModal !== "EditSecondment" ? setShowModal(undefined) : setShowSecondModal(undefined);
                            break;
                        default:
                            break;
                    }
                }}
                visible={tab === "service" ? (showModal === "DeleteService" || showSecondModal === "DeleteService") :
                    tab === "product" ? (showModal === "DeleteProduct" || showSecondModal === "DeleteProduct") :
                        tab === "secondment" ? (showModal === "DeleteSecondment" || showSecondModal === "DeleteSecondment") : false
                }
                zIndex={2000000}
                tab={tab?.toString()}
            />
            <ApproveConfirmModal
                approveService={() => {
                    approveOffering();
                }}
                toggleModal={() => {
                    if (tab === "service") {
                        showModal !== "EditService" ? setShowModal(undefined) : setShowSecondModal(undefined);
                    } else {
                        showModal !== "EditProduct" ? setShowModal(undefined) : setShowSecondModal(undefined);
                    }
                }}
                visible={tab === "service" ? (showModal === "ApproveService" || showSecondModal === "ApproveService") :
                    (showModal === "ApproveProduct" || showSecondModal === "ApproveProduct")
                }
                zIndex={2000000}
                tab={tab?.toString()}
            />

            <RejectConfirmModal
                rejectService={(e) => {
                    rejectOffering(e);
                }}
                toggleModal={() => {
                    if (tab === "service") {
                        showModal !== "EditService" ? setShowModal(undefined) : setShowSecondModal(undefined);
                    } else {
                        showModal !== "EditProduct" ? setShowModal(undefined) : setShowSecondModal(undefined);
                    }
                }}
                visible={tab === "service" ? (showModal === "RejectService" || showSecondModal === "RejectService") :
                    (showModal === "RejectProduct" || showSecondModal === "RejectProduct")
                }
                zIndex={2000000}
                tab={tab?.toString()}
                isHeightMobile={isMobileScreen}
            />

            <AddContactModal
                toggleModal={async () => {
                    await getFirmProfile();
                    setShowModal(undefined);
                }}
                visible={showModal === "Contact"}
                data={firmProfileData!}
            />

            <AddSecondmentContactModal
                toggleModal={async () => {
                    await getFirmProfile();
                    setShowModal(undefined);
                }}
                visible={showModal === "SecondmentContact"}
                data={firmProfileData!}
            />
            <AddBrochureModal
                toggleModal={async () => {
                    await getFirmProfile();
                    setShowModal(undefined);
                }}
                visible={showModal === "Brochure"}
                data={firmProfileData!}
            />
            <AddVideoModal
                toggleModal={() => {
                    getFirmProfile();
                    setShowModal(undefined);
                }}
                visible={showModal === "Video"}
                data={firmProfileData!}
            />
            <AddHeaderdModal
                toggleModal={() => {
                    getFirmProfile();
                    setShowModal(undefined);
                }}
                visible={showModal === "Header"}
                data={firmProfileData}
            />
            <AddDescriptionModal
                toggleModal={async () => {
                    await getFirmProfile();
                    setShowModal(undefined);
                }}
                visible={showModal === "Description"}
                data={firmProfileData}
                isHeightMobile={isMobileScreen}
            />

            <FormMessageModal
                isShow={showModal === "SendMessage"}
                handleClose={() => {
                    setShowModal(undefined);
                }}
                handleShowNoti={(firmNotSend) => { }}
                dataFirm={
                    !serviceId
                        ? [{ firmID: firmProfileData?.fkFirmId }]
                        : [{ services: [{ comOfferingId: Number(serviceId) }] }]
                }
                dataServiceLevel={
                    [{
                        firmID: firmProfileData?.fkFirmId,
                        service: {
                            comOfferingId: Number(serviceId)
                        }
                    }]
                }
                sendTo={!serviceId ? "Firm" : "Service"}
                pageType={!serviceId ? "Firm" : (tab === "secondment" ? "": capitalize(tab || ""))}
            />

            <FormMessageModal
                isShow={showModal === "SendOrgSecondmentMessage"}
                handleClose={() => {
                    setShowModal(undefined);
                }}
                handleShowNoti={(firmNotSend) => { }}
                dataFirm={
                    !serviceId
                        ? [{ firmID: firmProfileData?.fkFirmId }]
                        : [{ services: [{ comOfferingId: Number(serviceId) }] }]
                }
                dataServiceLevel={
                    [{
                        firmID: firmProfileData?.fkFirmId,
                        service: {
                            comOfferingId: Number(serviceId)
                        }
                    }]
                }
                sendTo={!serviceId ? "Firm" : "Service"}
                pageType={!serviceId ? "Firm" : capitalize(tab || "")}
                isSecondmentContactSend={true}
            />

            <RegionContactFormMessageModal
                isShow={showModal === "SendRegionMessage"}
                handleClose={() => {
                    setShowModal(undefined);
                }}
                handleShowNoti={(firmNotSend) => { }}
                regionId={selectedRegion}
                dataFirm={
                    [{ services: [{ comOfferingId: Number(serviceId) }] }]
                }
                sendTo={"Service"}
                pageType={!serviceId ? "Firm" : capitalize(tab || "")}
            />

            <div className="mobile2:mx-[15px] mobile2:mt-[80px]">
                <Container className="back-container flex-col ">
                    {serviceId &&
                        serviceDetail &&
                        today.diff(
                            moment(serviceDetail.commerceFirmData?.lastUpdate),
                            "years",
                        ) >= user?.individual.remindTime! &&
                        !serviceDetail.isDraft && (
                            <RolesHandleAdmin
                                firmId={firmProfileData?.fkFirmId!}
                                bypassIndividualIds={serviceDetail?.individuals?.map(
                                    (e) => e.id!,
                                )}
                                roles={[
                                    "Admin",
                                    "FirmCommerceManagement",
                                    "ManagingPartner",
                                    "VendorUser"
                                ]}>
                                <div className="m-auto my-[10px] w-full">
                                    <InfomationLookGood className="back-container infor-look-good">
                                        <div></div>
                                        <div className="gr-text">
                                            This {handleTextByTab(tab!.toString())} has been active for over a year. Please confirm if your information is correct.
                                        </div>
                                        <div className="gr-button">
                                            <button
                                                onClick={() =>
                                                    // tab === "service" ? setShowModal("EditService") : setShowModal("EditProduct")
                                                    handleStateByTab(tab!.toString(), "update")
                                                }>
                                                Edit
                                            </button>
                                            <button
                                                onClick={() =>
                                                    informationLookGood()
                                                }>
                                                Confirm
                                            </button>
                                        </div>
                                    </InfomationLookGood>
                                </div>
                            </RolesHandleAdmin>
                        )}
                    {serviceId &&
                        serviceDetail &&
                        serviceDetail.commerceFirmData?.fkStatusId === 1 &&
                        (
                            <RolesHandle
                                firmId={firmProfileData?.fkFirmId!}
                                bypassIndividualIds={serviceDetail?.individuals?.map(
                                    (e) => e.id!,
                                )}
                                roles={[
                                    "Admin",
                                    "FirmCommerceManagement",
                                    "ManagingPartner",
                                ]}>
                                <div className="m-auto my-[10px] w-full">
                                    <InfomationLookGood className="back-container infor-look-good">
                                        <div></div>
                                        <div className="gr-text">
                                            This {tab === "service" ? "service" : "product"} has been edited and requires your approval as an Admin.
                                        </div>
                                        <div className="gr-button">
                                            <button
                                                onClick={() =>
                                                    setShowModal(tab === "service" ? "ApproveService" : "ApproveProduct")
                                                }>
                                                Approve
                                            </button>
                                            <button
                                                onClick={() =>
                                                    tab === "service" ? setShowModal("RejectService") : setShowModal("RejectProduct")
                                                }>
                                                Reject
                                            </button>
                                        </div>
                                    </InfomationLookGood>
                                </div>
                            </RolesHandle>
                        )}
                    <div className="flex w-full">
                        <Div className={`header-button w-5/6 flex ${serviceId ? `mobile2:flex-col mobile2:w-1/2` : `mobile2:w-full`} `}>
                            <RolesHandleInquiries
                                firmId={Number(firmId) ?? 0}
                                fkOrgId={user!.individual!.fkOrgId}
                                roles={["Admin", "FirmCommerceManagement", "ManagingPartner", "ServiceContact"]}
                            >
                                <AGButton
                                    className="flex justify-end mobile2:max-w-[115px]"
                                    onClick={() => {
                                        // Get the redirect URL from localStorage with a fallback
                                        const baseUrl = localStorage.getItem(KEY_ITEM_LOCALSTORAGE.REDIRECT_URL_COMPARE_SERVICE) || "/search-firms";
                                        
                                        // Construct the new URL with the back-to-results parameter
                                        const url = new URL(baseUrl, window.location.origin);
                                        url.searchParams.set('isBackToRs', 'true');
                                        // Navigate to the updated URL
                                        window.location.href = url.toString();
                                    }}
                                    type="Link"
                                    icon={<BackIcon />}>
                                    Back to results
                                </AGButton>
                            </RolesHandleInquiries>
                            <div className="flex w-full">
                                <AGButton
                                    className="ml-[5px] mobile2:ml-[2px]"
                                    onClick={() => {
                                        setSearchParams({
                                            // Only redirect to Home page
                                            // ...searchParamsObject,
                                            tab: 'home',
                                            serviceId: ""
                                        });
                                    }}
                                    type={`${serviceId ? "Link" : "InLink"}`}
                                    icon={<BackIcon />}>
                                    <span >Organization Profile</span>
                                </AGButton>
                                {
                                    serviceId &&
                                    <AGButton
                                        type="InLink"
                                        icon={<BackIcon />}>
                                        <span className=" w-full line-clamp-1 text-left">{serviceDetail?.comMainServices?.mainServiceName ? serviceDetail!.comMainServices!.mainServiceName : ''}</span>
                                    </AGButton>
                                }
                            </div>
                        </Div>
                    </div>
                </Container>
            </div>

            <Container className="container ">
                <FirmBackGound className="card-firm-profile">
                    <Div className="card-backgound">
                        <Div className="card-firm-backgound">
                            {firmProfileData?.backgroundPart ? (
                                // eslint-disable-next-line jsx-a11y/alt-text
                                <img
                                    className="h-full object-fill w-full  rounded-t-[10px]"
                                    src={`${apiDomain}${API_CONSTANT.DEFAULT_PROFILE.IMG
                                        }${encodeURIComponent(
                                            firmProfileData?.backgroundPart!,
                                        )}`}
                                />
                            ) : null}
                            <Div className="backgound">
                                <Div className="edit-header-btn absolute top-0 right-0">
                                    {!serviceId &&
                                        <RolesHandle
                                            firmId={firmProfileData?.fkFirmId!}
                                            roles={[
                                                "Admin",
                                                "FirmCommerceManagement",
                                            ]}>
                                            <Div
                                                className="edit-icon"
                                                onClick={() => {
                                                    setShowModal("Header");
                                                }}>
                                                <PenIcon />
                                            </Div>
                                        </RolesHandle>
                                    }
                                </Div>
                            </Div>
                            {!serviceId &&
                                <Div className="edit-logo">
                                    <RolesHandle
                                        firmId={firmProfileData?.fkFirmId!}
                                        roles={[
                                            "Admin",
                                            "FirmCommerceManagement",
                                        ]}>
                                        <Div
                                            className="edit-icon"
                                            onClick={() => {
                                                setShowModal("Header");
                                            }}>
                                            <PenIcon />
                                        </Div>
                                    </RolesHandle>
                                </Div>}
                            <Div className={`card-logo`}>
                                {firmProfileData?.logoPart &&
                                    firmProfileData?.logoPart.length ? (
                                    firmProfileData.defaultLogo ? (
                                        <Logo bg={firmProfileData?.logoPart} />
                                    ) : (
                                        <Logo
                                            bg={`${apiDomain}${API_CONSTANT.DEFAULT_PROFILE.IMG
                                                }${encodeURIComponent(
                                                    firmProfileData?.logoPart!,
                                                )}`}
                                        />
                                    )
                                ) : (
                                    <Logo />
                                )}
                            </Div>
                        </Div>
                        <Div className="card-firm-bottom">
                            {!serviceId ?
                                <>
                                    <Div className="edit-header-btn">
                                        <RolesHandle
                                            firmId={firmProfileData?.fkFirmId!}
                                            roles={[
                                                "Admin",
                                                "FirmCommerceManagement",
                                            ]}>
                                            <Div
                                                className="edit-icon"
                                                onClick={() => {
                                                    setShowModal("Description");
                                                }}>
                                                <PenIcon />
                                            </Div>
                                        </RolesHandle>
                                    </Div>
                                    <Div className="card-firm-info">
                                        <div className="flex items-center justify-center">
                                            <h2 className="firm-tagname flex-1 text-[#333333]" onClick={() => {
                                                // handleNavigate(`${API_CONSTANT.DEFAULT_PROFILE.PROFILE}/${firmId}`, { serviceId: "" });
                                                const searchParamsObject = Object.fromEntries(searchParams.entries());

                                                setSearchParams({
                                                    ...searchParamsObject,
                                                    tab: 'home',
                                                });
                                            }}>
                                                {firmProfileData?.firmName}
                                            </h2>
                                            {firmProfileData && (firmProfileData?.orgType === 4 || firmProfileData?.orgType === 5) &&
                                                <TagVendor className="flex h-[23px] bg-[#333333] text-white items-center justify-center py-[10px] px-[10px] rounded-[5px] ml-auto font-[500]">
                                                    {firmProfileData?.orgType === 4 ? "STRATEGIC PARTNER" : "PREFERRED VENDOR"}
                                                </TagVendor>
                                            }
                                        </div>
                                        {firmProfileData?.tagLine && (
                                            <p className="firm-tagline text-[#333333]">
                                                {firmProfileData?.tagLine
                                                    ? firmProfileData?.tagLine
                                                    : ""}
                                            </p>
                                        )}
                                        {firmProfileData?.city && firmProfileData?.stateOrProvince && firmProfileData?.country &&
                                            <p className="firm-location !text-[#637381]">
                                                {firmProfileData?.city}
                                                {
                                                    firmProfileData?.stateOrProvince === "__" ? "" : ", " + firmProfileData?.stateOrProvince
                                                }
                                                {
                                                    firmProfileData?.country && (<>, {firmProfileData.country}</>)
                                                }
                                            </p>
                                        }
                                        <div className="firm-url flex">
                                            {firmProfileData?.offerorURL && (
                                                <>
                                                    <div className="url-icon">
                                                        <URLLinkIcon />
                                                    </div>
                                                    <a className="firm-url-info text-[14px] justify-center items-center" href={firmProfileData?.offerorURL} >
                                                        <p className="firm-url-info line-clamp-1">{firmProfileData?.offerorURL}</p>
                                                    </a>
                                                </>)}
                                        </div>
                                    </Div>
                                    <Div className="nav-page">
                                        <ul className="nav-list">
                                            <li>
                                                <p
                                                    className={`nav-list-item cursor-pointer ${tab === "home" ? "NavItemActive" : ""}`}
                                                    onClick={() => {
                                                        setServiceDetail(undefined);
                                                        handleDeleteParam();
                                                        const searchParamsObject = Object.fromEntries(searchParams.entries());

                                                        setSearchParams({
                                                            ...searchParamsObject,
                                                            tab: 'home',
                                                        });
                                                        setFirstViewProfile(false);
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    Home
                                                </p>
                                            </li>
                                            <li>
                                                <p
                                                    className={`nav-list-item cursor-pointer ${tab === "service" ? "NavItemActive" : ""}`}
                                                    onClick={() => {
                                                        handleDeleteParam();
                                                        setServiceDetail(undefined);
                                                        const searchParamsObject = Object.fromEntries(searchParams.entries());

                                                        setSearchParams({
                                                            ...searchParamsObject,
                                                            tab: 'service',
                                                        });
                                                        setFirstViewProfile(false);
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    Services
                                                </p>
                                            </li>
                                            <li>
                                                <p
                                                    className={`nav-list-item cursor-pointer ${tab === "product" ? "NavItemActive" : ""}`}
                                                    onClick={() => {
                                                        handleDeleteParam();
                                                        setServiceDetail(undefined);
                                                        const searchParamsObject = Object.fromEntries(searchParams.entries());

                                                        setSearchParams({
                                                            ...searchParamsObject,
                                                            tab: 'product',
                                                        });
                                                        setFirstViewProfile(false);
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    Products
                                                </p>
                                            </li>
                                            {/* <li>
                                        <p
                                            className={`nav-list-item cursor-pointer ${
                                                tab === "orporateFinance" ? "NavItemActive" : ""
                                            }`}
                                            onClick={() => {
                                                handleDeleteParam();
                                                setServiceDetail(undefined);
                                            }}
                                        >
                                            Corporate Finance
                                        </p>
                                        </li> */}
                                            {
                                                firmProfileData?.orgType === 1 &&
                                                <RolesHandleInquiries
                                                    firmId={Number(firmId) ?? 0}
                                                    fkOrgId={user!.individual!.fkOrgId}
                                                    roles={["Admin", "FirmCommerceManagement", "ManagingPartner", "ServiceContact"]}
                                                >
                                                    <li>
                                                        <p
                                                            className={`nav-list-item cursor-pointer ${tab === "secondment" ? "NavItemActive" : ""}`}
                                                            onClick={() => {
                                                                handleDeleteParam();
                                                                setServiceDetail(undefined);
                                                                const searchParamsObject = Object.fromEntries(searchParams.entries());

                                                                setSearchParams({
                                                                    ...searchParamsObject,
                                                                    tab: 'secondment',
                                                                });
                                                            }}
                                                        >
                                                            Secondments
                                                        </p>
                                                    </li>
                                                </RolesHandleInquiries>
                                            }
                                        </ul>
                                    </Div>

                                </> : <>
                                    <Div className="card-firm-info flex pt-[15px] w-full">
                                        <div className={`flex py-[15px] cursor-pointer ${isSponsorProfile() ? "w-1/3 sizeFixedMobile:w-[45%]" : "w-full sizeFixedMobile:w-full"}`} >
                                            <p className="text-[14px] flex font-[700] text-[#333333] leading-[16.41px] cursor-pointer min-w-[160px]" onClick={() => {
                                                setSearchParams({
                                                    tab: tab!.toString(),
                                                });
                                                handleDeleteParam();
                                                setServiceDetail(undefined);
                                                setFirstViewProfile(true);
                                            }}>
                                                <div className="back-icon pr-[20px]"><BackIcon1 /></div>
                                                View other {tab === "service" ? "services" :
                                                    tab === "product" ? "products" :
                                                        tab === "secondment" ? "secondments" : ""}
                                            </p>
                                        </div>
                                        {serviceDetail && !isMobileScreenPage ? (
                                            <>
                                                <div className="sponsor-profile sizeFixedMobile:w-1/2 w-full">
                                                    <div className="flex ml-auto mt-[10px] w-full justify-end gap-[10px]">
                                                        {
                                                            serviceDetail?.sponsorProfile &&
                                                            serviceDetail?.sponsorProfile === true &&
                                                            moment(serviceDetail?.sponsorStartDate).isSameOrBefore(moment(), 'day') &&
                                                            !isMobileScreenPage &&
                                                            <>
                                                                <div className=" text-[#03A100] text-[14px]">
                                                                    <p className="line-clamp-1 text-end">{serviceDetail.sponsorMessage}</p>
                                                                </div>
                                                                <TagSponsorService>SPONSORED</TagSponsorService>
                                                            </>
                                                        }
                                                        {firmProfileData && (firmProfileData?.orgType === 4 || firmProfileData?.orgType === 5) &&
                                                            <TagVendor className="flex h-[23px] bg-[#333333] text-white items-center text-nowrap justify-center py-[10px] px-[10px] rounded-[5px] font-[500]">
                                                                {firmProfileData?.orgType === 4 ? "STRATEGIC PARTNER" : "PREFERRED VENDOR"}
                                                            </TagVendor>
                                                        }
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        {isSponsorProfile() && serviceDetail && isMobileScreenPage ? (
                                            <div className={`sponsor-profile flex justify-start sizeFixedMobile:w-[55%] w-full`}>
                                                <div className={`ml-auto mt-[10px] w-full flex flex-wrap justify-end gap-[5px] right-0`}>
                                                    {serviceDetail?.sponsorProfile && serviceDetail?.sponsorProfile === true && isMobileScreenPage && moment(serviceDetail?.sponsorStartDate).isSameOrBefore(moment(), 'day') &&
                                                        <TagSponsorService>SPONSORED</TagSponsorService>
                                                    }
                                                    {firmProfileData && (firmProfileData?.orgType === 4 || firmProfileData?.orgType === 5) &&
                                                        <TagVendor className="flex h-[23px] w-[121px] bg-[#333333] text-white items-center justify-center whitespace-nowrap py-[10px] px-[10px] rounded-[5px] font-[500]">
                                                            {firmProfileData?.orgType === 4 ? "STRATEGIC PARTNER" : "PREFERRED VENDOR"}
                                                        </TagVendor>
                                                    }
                                                </div>
                                            </div>
                                        ) : null}
                                    </Div>
                                    {serviceDetail?.sponsorProfile && serviceDetail?.sponsorProfile === true && moment(serviceDetail?.sponsorStartDate).isSameOrBefore(moment(), 'day') && isMobileScreenPage ? (
                                        <div className="w-full text-right text-[#03A100] text-[14px] px-[20px]">
                                            <p className="line-clamp-1 w-full pb-[10px]">{serviceDetail.sponsorMessage}</p>
                                        </div>) : null
                                    }
                                </>
                            }
                        </Div>
                    </Div>
                    <CompleteCreateServiceModal
                        submitAnother={() => {
                            if (tab === "service") {
                                setShowModalAddService(true);
                                setShowModalThank(false);
                            } else if (tab === "product") {
                                setShowModalAddProduct(true);
                                setShowModalThank(false);
                            } else if (tab === "secondment") {
                                setShowModalAddSecondment(true);
                                setShowModalThank(false);
                            }
                        }}
                        visible={showModalThank}
                        toggleModal={() => {
                            if (tab === "service") {
                                setShowModalAddService(false);
                                setShowModalThank(false);
                            } else {
                                setShowModalAddProduct(false);
                                setShowModalThank(false);
                            }
                        }}
                        showSubmitAnother={
                            tab === "service" ? ((serviceData?.length ?? 0) < (user?.individual?.serviceMaximumQuantity ?? 0) || (user?.roles?.includes("Admin") && firmId === ADMIN_ORGANIZATION.ID.toString())) :
                                tab === "product" ? ((productsData?.length ?? 0) < (user?.individual?.productMaximumQuantity ?? 0) || (user?.roles?.includes("Admin") && firmId === ADMIN_ORGANIZATION.ID.toString())) :
                                    tab === "secondment" ? true : false
                        }
                        comOfferingType={tab === "service" ? "service" :
                            tab === "product" ? "product" :
                                tab === "secondment" ? "secondment" : ""}
                    />

                    {!serviceDetail && (tab === "home") &&
                        (firmProfileData?.description ||
                            rolesAndPermissionByFirm(
                                ["Admin", "FirmCommerceManagement"],
                                firmProfileData?.fkFirmId,
                            )) ? (
                        <FirmAddDesciption className="add-description">
                            <CardItem
                                header="Description"
                                headerIcon={
                                    firmProfileData?.description && (
                                        <PenIcon />
                                    )
                                }
                                serviceList={false}
                                setShow={() => {
                                    setShowModal("Description");
                                }}
                                firmId={firmProfileData?.fkFirmId!}
                                children={
                                    <DescriptionModal
                                        bodyContent="Add description"
                                        data={firmProfileData}
                                        setShow={() => {
                                            setShowModal("Description");
                                        }}
                                    />
                                }
                            />
                        </FirmAddDesciption>
                    ) : null
                    }

                    <AddServiceModal
                        toggleModal={() => {
                            setShowModalAddService(false);
                            getSelectedServ(firmId);
                        }}
                        visible={showModalAddService}
                        submitComplete={() => {
                            setShowModalAddService(false);
                            setShowModalThank(true);
                            getSelectedServ(firmId);
                        }}
                    />

                    <AddProductModal
                        toggleModal={() => {
                            setShowModalAddProduct(false);
                            getProducts(firmId);
                        }}
                        visible={showModalAddProduct}
                        submitComplete={() => {
                            setShowModalAddProduct(false);
                            setShowModalThank(true);
                            getProducts(firmId);
                        }}
                    />

                    <AddSecondmentModal
                        toggleModal={() => {
                            setShowModalAddSecondment(false);
                            getAllSecondments(firmId);
                        }}
                        visible={showModalAddSecondment}
                        submitComplete={() => {
                            setShowModalAddSecondment(false);
                            setShowModalThank(true);
                            getAllSecondments(firmId);
                        }}
                    />

                    {/* Reject messages */}
                    {serviceId && serviceDetail && serviceDetail.commerceFirmData?.fkStatusId === 3 && serviceDetail!.comOfferingAproveOrRejectLog!.length > 0 && (
                        <div className="mb-[10px] px-[20px]">
                            <p className="text-red-600">Rejection Reason:</p>
                            {serviceDetail!.comOfferingAproveOrRejectLog!
                                .slice()
                                .sort(
                                    (a, b) => new Date(b.createDate!).getTime() - new Date(a.createDate!).getTime(),
                                )
                                .map((item, index) => (
                                    <RejectMessage key={index} className="text-red-600 flex gap-[5px] w-[100%]">
                                        <p className="text-red-600 whitespace-nowrap">
                                            - {formatDate(item.createDate)}:
                                        </p>
                                        <p className="text-red-600 whitespace-pre-line">
                                            {item.messageRejected}
                                        </p>
                                    </RejectMessage>
                                ))}
                        </div>
                    )}

                    {!serviceDetail && tab === "service" &&
                        <ServiceList className="add-description">
                            <CardItem
                                header=""
                                headerIcon={<></>}
                                setShow={() => {
                                    setShowModalAddService(true);
                                }}
                                buttonText="Add New"
                                buttonTextClassName="serviceBtn"
                                firmId={firmProfileData?.fkFirmId!}
                                serviceList={true}
                                isReload={showModalAddService}
                                children={
                                    <ThumbnailContainer
                                        data={serviceData}
                                        onchangeService={(e) => {
                                            getServiceDetailData(e);
                                        }} />
                                }
                            />
                        </ServiceList>
                    }
                    {!serviceDetail && tab === "product" &&
                        <ProductList className="add-description">
                            <ProductItems
                                header=""
                                headerIcon={<></>}
                                setShow={() => {
                                    setShowModalAddProduct(true);
                                }}
                                buttonText="Add New"
                                buttonTextClassName="serviceBtn"
                                firmId={firmProfileData?.fkFirmId!}
                                isReload={showModalAddProduct}
                                children={
                                    <ProductsThumbnailContainer
                                        data={productsData}
                                        onchangeService={(e) => {
                                            getProducts(e);
                                        }} />
                                }
                            />
                        </ProductList>
                    }

                    {!serviceDetail && tab === "secondment" &&
                        <ProductList className="add-description">
                            <SecondmentItems
                                header=""
                                headerIcon={<></>}
                                setShow={() => {
                                    setShowModalAddSecondment(true);
                                }}
                                buttonText="Add New"
                                buttonTextClassName="serviceBtn"
                                firmId={firmProfileData?.fkFirmId!}
                                isReload={showModalAddSecondment}
                                countData={(secondmentsData?.length || 0)}
                                countSeekingData={secondmentsSeekingData?.length || 0}
                                createdSecondment={createdOfferings || 0}
                                children={
                                    <SecondmentsThumbnailContainer
                                        isShowLogo={false}
                                        data={secondmentsData}
                                        onchangeService={(e) => {
                                            getAllSecondments(e);
                                        }} />
                                }
                                childrenSeeking={
                                    <SecondmentsThumbnailContainer
                                        data={secondmentsSeekingData}
                                        isShowLogo={false}
                                        onchangeService={(e) => {
                                            getAllSecondments(e);
                                        }} />
                                }
                            />
                        </ProductList>
                    }

                    {serviceId && serviceDetail && tab !== "secondment" && (
                        <CardItem
                            header={
                                serviceDetail.comMainServices?.mainServiceName
                            }
                            headerIcon={!serviceId && <PenIcon />}
                            tagService={
                                serviceDetail.isDraft ? "Draft" : serviceDetail.commerceFirmData?.fkStatusId && isRolesVendor({
                                    currentUser: user,
                                    fkOrgId: Number(firmId)
                                }) ? handleStatusMessage(serviceDetail.commerceFirmData?.fkStatusId) : undefined
                            }
                            setShow={() => {
                                setShowModal("Description");
                            }}
                            firmId={firmProfileData?.fkFirmId!}
                            children={
                                <ServiceDescriptionModal
                                    industyData={
                                        serviceDetail.comrelevantIndustry
                                            ?.industryName
                                    }
                                    data={serviceDetail.commerceFirmData}
                                    tab={tab?.toString()}
                                />
                            }
                            SecondInfo={true}
                            subHeader={serviceDetail.comrelevantIndustry?.industryName ? `Industry niches we serve for this service` : undefined}
                            subChildren={
                                serviceDetail.comrelevantIndustry?.industryName ?
                                    <IndustryNichesModal
                                        industyData={
                                            serviceDetail.comrelevantIndustry
                                                ?.industryName
                                        }
                                        data={serviceDetail.commerceFirmData}
                                    /> : null
                            }
                            memberBenefirHeader={firmProfileData && showMemberBenefit(firmProfileData, serviceDetail) && serviceDetail.commerceFirmData?.memberBenefits ? `Member Benefits` : undefined}
                            memberChildren={serviceDetail.commerceFirmData?.memberBenefits ?
                                <MemberBenefitModal
                                    bodyContent={
                                        serviceDetail.commerceFirmData
                                            ?.memberBenefits
                                    }
                                    data={serviceDetail.commerceFirmData}
                                /> : null
                            }
                        />
                    )}
                    {serviceId && tab === "secondment" && serviceDetail && (
                        <CardItem
                            header={
                                serviceDetail.comMainServices?.mainServiceName
                            }
                            secondmentTitle={serviceDetail.commerceFirmData?.title}
                            headerIcon={!serviceId && <PenIcon />}
                            tagService={
                                serviceDetail.isDraft ? "Draft" : serviceDetail.commerceFirmData?.fkStatusId && isRolesVendor({
                                    currentUser: user,
                                    fkOrgId: Number(firmId)
                                }) ? handleStatusMessage(serviceDetail.commerceFirmData?.fkStatusId) : undefined
                            }
                            setShow={() => {
                                setShowModal("Description");
                            }}
                            firmId={firmProfileData?.fkFirmId!}
                            children={null}
                            SecondInfo={true}
                            secondmentDescriptions={serviceDetail.commerceFirmData?.detailedDescription}
                            firmRegion={serviceDetail.netRegion?.netRegionName}
                        />
                    )}
                    {
                        serviceId && serviceDetail && tab !== "secondment" && (
                            <CardItem
                                header={tab === "service" ?
                                    "Distinct Areas of Expertise & Competency Scale Rating" : "Distinct Product Category"
                                }
                                isShowToggleButton={true}
                                isShowCollapse={false}
                                titleTooltip={tab === "service" ? MESSAGE_TOOLTIP.PRACTICEL_LEVEL : undefined}
                                headerIcon={!serviceId && <PenIcon />}
                                setShow={() => {
                                    setShowModal("Description");
                                }}
                                firmId={firmProfileData?.fkFirmId!}
                                className="mobile-header-distance"
                                childrenClassName="mobile-content-distance"
                                children={
                                    <DistAreaModal
                                        serviceId={serviceId!}
                                        firmAvailData={serviceDetail}
                                        tab={tab?.toString()}
                                    />
                                }
                            />
                        )}
                </FirmBackGound>
                <FirmContactBrochureAttach className="card-left-profile">
                    {!serviceId &&
                        (firmProfileData?.firmProfileContacts.length ||
                            rolesAndPermissionByFirm(
                                ["Admin", "FirmCommerceManagement"],
                                firmProfileData?.fkFirmId,
                            )) && (
                            <CardItem
                                header={
                                    <div className="flex items-center gap-2">
                                        <span>Organization Contact</span>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setShowModal("SendMessage");
                                            }}
                                            className="inline-flex items-center text-[#0971A2] ml-1 translate-y-[3px]"
                                            aria-label="Send inquiry"
                                        >
                                            <InquiriesIcon className="fill-[#0971A2] w-[22px] h-[22px]" />
                                        </button>
                                    </div>
                                }
                                headerIcon={
                                    !serviceId &&
                                        firmProfileData?.firmProfileContacts &&
                                        firmProfileData?.firmProfileContacts
                                            .length ? (
                                        <PenIcon />
                                    ) : null
                                }
                                bodyContent="Add contact"
                                setShow={() => {
                                    setShowModal("Contact");
                                }}
                                serviceList={false}
                                firmId={firmProfileData?.fkFirmId!}
                                children={
                                    <ContactModal
                                        bodyContent="Add contact"
                                        data={firmProfileData!}
                                        setShow={() => {
                                            setShowModal("Contact");
                                        }}
                                        setShowSendMessage={() => {
                                            setShowModal("SendMessage");
                                        }}
                                    />
                                }
                            />
                        )}
                    
                    {!serviceId && firmProfileData && firmProfileData.orgType === ORGANIZATION_TYPE.MEMBER &&
                        (firmProfileData?.firmSecondmentContacts.length ||
                            rolesAndPermissionByFirm(
                                ["Admin", "FirmCommerceManagement"],
                                firmProfileData?.fkFirmId,
                            )) && (
                            <CardItem
                                header={
                                    <div className="flex items-center gap-2">
                                        <span>Secondment Contact</span>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setShowModal("SendOrgSecondmentMessage");
                                            }}
                                            className="inline-flex items-center text-[#0971A2] ml-1 translate-y-[3px]"
                                            aria-label="Send inquiry"
                                        >
                                            <InquiriesIcon className="fill-[#0971A2] w-[22px] h-[22px]" />
                                        </button>
                                    </div>
                                }
                                headerIcon={
                                    !serviceId &&
                                        firmProfileData?.firmSecondmentContacts &&
                                        firmProfileData?.firmSecondmentContacts
                                            .length ? (
                                        <PenIcon />
                                    ) : null
                                }
                                bodyContent="Add contact"
                                setShow={() => {
                                    setShowModal("SecondmentContact");
                                }}
                                serviceList={false}
                                firmId={firmProfileData?.fkFirmId!}
                                children={
                                    <FirmSecondmentContactModal
                                        bodyContent="Add contact"
                                        data={firmProfileData!}
                                        setShow={() => {
                                            setShowModal("SecondmentContact");
                                        }}
                                        setShowSendMessage={() => {
                                            setShowModal("SendOrgSecondmentMessage");
                                        }}
                                    />
                                }
                            />
                        )}

                    {serviceId && serviceDetail &&
                        tab !== "secondment" &&
                        serviceDetail.individuals &&
                        serviceDetail!.individuals!.length ? (
                        <CardItem
                            header={
                                <div className="flex items-center gap-2">
                                    <span>{tab === `service` ? `Contact for this service` : `Contact for this product`}</span>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowModal("SendMessage");
                                        }}
                                        className="inline-flex items-center text-[#0971A2] ml-1 translate-y-[3px]"
                                        aria-label="Send inquiry"
                                    >
                                        <InquiriesIcon className="fill-[#0971A2] w-[22px] h-[22px]" />
                                    </button>
                                </div>
                            }
                            isShowToggleButton={true}
                            isShowCollapse={false}
                            headerIcon={!serviceId && <PenIcon />}
                            bodyContent="Add contact"
                            setShow={() => {
                                setShowModal("Contact");
                            }}
                            firmId={firmProfileData?.fkFirmId!}
                            children={
                                <ServiceContactsModal
                                    data={firmProfileData}
                                    dataService={serviceDetail}
                                    setShow={() => {
                                        setShowModal("Contact");
                                    }}
                                />
                            }
                        />
                    ) : null}

                    {serviceId && serviceDetail &&
                        tab === "secondment" &&
                        serviceDetail.individuals &&
                        serviceDetail!.individuals!.length ? (
                        <CardItem
                            header={
                                <div className="flex items-center gap-2">
                                    <span>Contact for this secondment</span>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowModal("SendMessage");
                                        }}
                                        className="inline-flex items-center text-[#0971A2] ml-1 translate-y-[3px]"
                                        aria-label="Send inquiry"
                                    >
                                        <InquiriesIcon className="fill-[#0971A2] w-[18px] h-[18px]" />
                                    </button>
                                </div>
                            }
                            isShowToggleButton={true}
                            isShowCollapse={false}
                            headerIcon={!serviceId && <PenIcon />}
                            bodyContent="Add contact"
                            setShow={() => {
                                setShowModal("Contact");
                            }}
                            firmId={firmProfileData?.fkFirmId!}
                            children={
                                <ServiceContactsModal
                                    dataService={serviceDetail}
                                    setShow={() => {
                                        setShowModal("Contact");
                                    }}
                                />
                            }
                        />
                    ) : null}

                    {serviceId && serviceDetail &&
                        serviceDetail.regionContacts &&
                        serviceDetail.regionContacts.length ? (
                        (
                            <CardItem
                                header="Region Contacts"
                                isShowToggleButton={true}
                                isShowCollapse={false}
                                headerIcon={!serviceId && <PenIcon />}
                                setShow={() => {
                                    // setShowModal("Contact");
                                }}
                                firmId={firmProfileData?.fkFirmId!}
                                children={
                                    <RegionContactsModal
                                        data={firmProfileData}
                                        dataServd={serviceDetail.regionContacts}
                                        dataService={serviceDetail}
                                        onSelectRegion={(regionId) => {
                                            setSelectedRegion(regionId);
                                        }}
                                        setShow={() => {
                                            // setShowModal("Contact");
                                        }}
                                        setShowSendMessage={() => {
                                            setShowModal("SendRegionMessage");
                                        }}
                                    />
                                }
                            />
                        )
                    ) : null}

                    {serviceDetail && serviceDetail?.commerceFirmData?.offerorLogoUrl &&
                        <CardItem
                            header={tab === "service" ? "Service Logo" : "Product Logo"}
                            isShowToggleButton={true}
                            isShowCollapse={false}
                            childrenClassName="mt-[0px]"
                            setShow={() => { }}
                            firmId={firmProfileData?.fkFirmId!}
                            children={
                                <ServiceLogoModal
                                    dataService={serviceDetail}
                                    tab={tab?.toString()}
                                />
                            }
                        />
                    }
                    {(serviceDetail?.commerceFirmData?.willingOfferAdvice ||
                        serviceDetail?.commerceFirmData?.loanStaff ||
                        serviceDetail?.commerceFirmData?.globalOpportunities ||
                        serviceDetail?.commerceFirmData?.receiveStaff ||
                        serviceDetail?.commerceFirmData?.acceptingClients) && serviceId && (
                            <CardItem
                                header="Service Availability"
                                isShowToggleButton={true}
                                isShowCollapse={false}
                                headerIcon={!serviceId && <PenIcon />}
                                bodyContent="Add contact"
                                setShow={() => {
                                    setShowModal("Contact");
                                }}
                                firmId={firmProfileData?.fkFirmId!}
                                children={
                                    <FirmAvailabilityModal
                                        firmAvailData={serviceDetail!}
                                    />
                                }
                            />
                        )}

                    {serviceDetail && serviceDetail?.commerceFirmData?.comOfferingSecondmentInterestTypes?.length ? (
                        <CardItem
                            header="Interest Type"
                            isShowToggleButton={true}
                            isShowCollapse={false}
                            headerIcon={!serviceId && <PenIcon />}
                            bodyContent=""
                            setShow={() => {
                                setShowModal("Contact");
                            }}
                            firmId={firmProfileData?.fkFirmId!}
                            children={
                                <SecondmentInterestTypes
                                    interestData={serviceDetail!}
                                />
                            }
                        />
                    ) : null}
                    {!serviceId &&
                        (firmProfileData?.brochurePath ||
                            rolesAndPermissionAdmin(
                                ["Admin"],
                                firmProfileData?.fkFirmId,
                            )) && (
                            <CardItem
                                header={"Company Brochure"}
                                serviceList={false}
                                headerIcon={
                                    <RolesHandleAdmin
                                        firmId={firmProfileData?.fkFirmId!}
                                        roles={["Admin"]}>
                                        {!serviceId &&
                                            firmProfileData?.brochurePath && (
                                                <PenIcon />
                                            )}
                                    </RolesHandleAdmin>
                                }
                                bodyContent="Add brochure"
                                setShow={() => {
                                    setShowModal("Brochure");
                                }}
                                firmId={firmProfileData?.fkFirmId!}
                                children={
                                    <BrochureItem
                                        onAdd={() => {
                                            setShowModal("Brochure");
                                        }}
                                        bodyContent="Add brochure"
                                        data={firmProfileData}
                                        setShow={() => {
                                            setShowModal("Brochure");
                                        }}
                                    />
                                }
                            />
                        )}
                    {serviceDetail?.pdf && (
                        <CardItem
                            header={tab === `service` ? `Service Brochure` : `Product Brochure`}
                            isShowToggleButton={true}
                            isShowCollapse={false}
                            headerIcon={
                                <RolesHandle
                                    firmId={firmProfileData?.fkFirmId!}
                                    roles={["Admin"]}>
                                    {!serviceId && <PenIcon />}
                                </RolesHandle>
                            }
                            bodyContent="Add brochure"
                            setShow={() => {
                                setShowModal("Brochure");
                            }}
                            firmId={firmProfileData?.fkFirmId!}
                            children={
                                <ServiceBrochureItem
                                    servicePdf={serviceDetail?.pdf}
                                    onAdd={() => {
                                        setShowModal("Brochure");
                                    }}
                                    bodyContent="Add brochure"
                                    isService={!serviceId}
                                    data={firmProfileData}
                                    setShow={() => {
                                        setShowModal("Brochure");
                                    }}
                                />
                            }
                        />
                    )}
                    {!serviceId &&
                        (firmProfileData?.videoUrl ||
                            rolesAndPermissionByFirm(
                                ["Admin", "FirmCommerceManagement"],
                                firmProfileData?.fkFirmId,
                            )) && (
                            <CardItem
                                header="Video"
                                headerIcon={
                                    !serviceId &&
                                    firmProfileData?.videoUrl && <PenIcon />
                                }
                                bodyContent="Add video"
                                setShow={() => {
                                    setShowModal("Video");
                                }}
                                firmId={firmProfileData?.fkFirmId!}
                                serviceList={false}
                                children={
                                    <VideoModal
                                        data={firmProfileData}
                                        isService={!serviceId}
                                        dataService={serviceDetail}
                                        bodyContent="Add video"
                                        setShow={() => {
                                            setShowModal("Video");
                                        }}
                                    />
                                }
                            />
                        )}

                    {serviceId &&
                        serviceDetail?.commerceFirmData?.videoLink && (
                            <CardItem
                                header="Video"
                                isShowToggleButton={true}
                                isShowCollapse={false}
                                setShow={() => {
                                    setShowModal("Video");
                                }}
                                firmId={firmProfileData?.fkFirmId!}
                                children={
                                    <ServiceVideoModal
                                        data={firmProfileData}
                                        isService={!serviceId}
                                        dataService={serviceDetail}
                                        bodyContent="Add video"
                                        setShow={() => {
                                            setShowModal("Video");
                                        }}
                                    />
                                }
                            />
                        )}
                    {serviceId && (
                        <RolesHandle
                            roles={[
                                "Admin",
                                "FirmCommerceManagement",
                                "ManagingPartner",
                            ]}
                            bypassIndividualIds={serviceDetail?.individuals?.map(
                                (e) => e.id!,
                            )}
                            firmId={serviceDetail?.firmName?.orgId!}>
                            <Card
                                style={{
                                    padding: "30px 0",
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: 10,
                                    flexWrap: "wrap"
                                }}>
                                {serviceId && (
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                        }}
                                        className="header-button">
                                        {serviceDetail && (
                                            <RolesHandle
                                                firmId={firmProfileData?.fkFirmId!}
                                                bypassIndividualIds={serviceDetail?.individuals?.map(
                                                    (e) => e.id!,
                                                )}
                                                roles={[
                                                    "Admin",
                                                    "FirmCommerceManagement",
                                                    "ManagingPartner"
                                                ]}>
                                                <AGButton
                                                    onClick={() => {
                                                        handleStateByTab(tab!.toString(), "update")
                                                    }}
                                                    type="Primary"
                                                    style={{ minWidth: "100px" }}
                                                >
                                                    {handleTextByTab(tab!.toString(), "update")}
                                                </AGButton>
                                            </RolesHandle>
                                        )}
                                    </div>
                                )}
                                <AGButton
                                    onClick={() => {
                                        handleStateByTab(tab!.toString(), "delete")
                                    }}
                                    style={{ minWidth: "100px" }}
                                    type="Danger">
                                    {handleTextByTab(tab!.toString(), "delete")}
                                </AGButton>
                            </Card>
                        </RolesHandle>
                    )}
                    {serviceId && serviceDetail && serviceDetail.commerceFirmData?.fkStatusId !== 1 && (
                        <RolesVendor
                            isDetail={true}
                            fkOrgId={Number(firmId)}
                            bypassIndividualIds={serviceDetail?.individuals?.map(
                                (e) => e.id!,
                            )}
                            roles={[
                                "Admin",
                                "FirmCommerceManagement",
                                "ManagingPartner"
                            ]}>
                            <Card
                                style={{
                                    padding: "30px 0",
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: 10,
                                    flexWrap: "wrap"
                                }}>
                                {serviceId && (
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                        }}
                                        className="header-button">
                                        <AGButton
                                            disabled={serviceDetail && serviceDetail.commerceFirmData?.fkStatusId === 1}
                                            onClick={() => {
                                                setShowModal(tab === "service" ? "EditService" : "EditProduct");
                                            }}
                                            type="Primary"
                                            style={{ minWidth: "100px" }}
                                        >
                                            {tab === "service" ? "Edit Service" : "Edit Product"}
                                        </AGButton>
                                    </div>
                                )}
                                <AGButton
                                    disabled={serviceDetail && serviceDetail.commerceFirmData?.fkStatusId === 1}
                                    onClick={() => {
                                        tab === "service" ? setShowModal("DeleteService") : setShowModal("DeleteProduct");
                                    }}
                                    style={{ minWidth: "100px" }}
                                    type="Danger">
                                    {tab === "service" ? "Delete Service" : "Delete Product"}
                                </AGButton>
                            </Card>
                        </RolesVendor>
                    )}
                </FirmContactBrochureAttach>
            </Container>
        </ProfileContainer>
    );
};

export default CommerceProfile;

export const PlusIcon = ({ className }: { className?: string }) => {
    return (
        <svg
            width="18"
            height="17"
            viewBox="0 0 18 17"
            className={className}
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.0748 7.00797H10.3598V0.292969H7.63981V7.00797H0.924805V9.72797H7.63981V16.443H10.3598V9.72797H17.0748V7.00797Z"
                fill="#0971A2"
            />
        </svg>
    );
};

export const PenIcon = () => {
    return (
        <PenIconStyled
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.20615 16.1426L0 20.3663L4.22375 19.1602L1.20615 16.1426Z"
                fill="#0971A2"
            />
            <path
                d="M19.9284 3.46349L17.9234 5.46845L14.9365 2.48153L16.9415 0.476562L19.9284 3.46349Z"
                fill="#0971A2"
            />
            <path
                d="M2.125 15.2518L14.0721 3.30469L17.059 6.29161L5.11192 18.2387L2.125 15.2518Z"
                fill="#0971A2"
            />
        </PenIconStyled>
    );
};

export const LinkIcon = () => {
    return (
        <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g path="url(#clip0_2522_5482)">
                <path
                    d="M10.0408 0.617143C8.02972 0.283869 5.97848 0.283869 3.96743 0.617143C3.03746 0.770964 2.17921 1.21279 1.51237 1.87933C0.846264 2.54675 0.404769 3.4056 0.251059 4.33611C-0.0836864 6.34862 -0.0836864 8.40216 0.251059 10.4137C0.404773 11.3444 0.846286 12.2041 1.51237 12.8705C2.17932 13.538 3.03757 13.9789 3.96743 14.1327C4.97171 14.2942 5.98708 14.3729 7.00423 14.3669C8.0213 14.3669 9.03754 14.2831 10.041 14.1156C10.971 13.9618 11.8301 13.5208 12.4961 12.8534C13.1631 12.186 13.6037 11.3272 13.7574 10.3967C13.9214 9.39511 14.0025 8.3816 13.9999 7.36627C13.9999 6.34849 13.9154 5.33154 13.7489 4.32734C13.5943 3.39928 13.1537 2.54301 12.4893 1.87734C11.824 1.21248 10.9684 0.771528 10.041 0.616858L10.0408 0.617143ZM12.2508 7.36662C12.2534 8.28869 12.1808 9.20907 12.0322 10.1183C11.8401 11.2891 10.9237 12.206 9.75377 12.3983C7.93397 12.7008 6.07664 12.7008 4.256 12.3983C3.08606 12.2069 2.16804 11.2899 1.97583 10.1183C1.67268 8.29722 1.67268 6.4386 1.97583 4.61669C2.16712 3.44592 3.08343 2.52726 4.25426 2.33492C6.07406 2.0307 7.93226 2.0307 9.75202 2.33492C10.922 2.52634 11.84 3.44329 12.0322 4.61494C12.1808 5.52419 12.2534 6.44457 12.2508 7.36662Z"
                    fill="rgb(44 118 170)"
                />
                <path
                    d="M8.29096 4.30473H5.66756C5.4182 4.30217 5.17908 4.40643 5.01171 4.59102C4.84689 4.77475 4.76747 5.02 4.79309 5.26526C4.85116 5.72245 5.24399 6.06342 5.70514 6.05489H7.05442L4.1748 8.93652C3.83236 9.27835 3.83236 9.83212 4.1748 10.1739C4.51639 10.5166 5.06977 10.5166 5.41134 10.1739L8.29096 7.29317V8.68012C8.2901 8.92795 8.39343 9.16465 8.57618 9.33131C8.75979 9.49795 9.00402 9.57913 9.25081 9.5552C9.70855 9.49794 10.0493 9.10399 10.0399 8.64252V6.05491C10.0399 5.59088 9.85543 5.14566 9.52749 4.81751C9.19956 4.48935 8.75464 4.30473 8.29096 4.30473Z"
                    fill="rgb(44 118 170)"
                />
            </g>
        </svg>
    );
};

export const CheckIcon = () => {
    return (
        <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g path="url(#clip0_2547_8116)">
                <path
                    d="M9.50465 5.39795C9.37614 5.52647 9.24872 5.65389 9.12075 5.78186C8.8134 6.0892 8.50552 6.39709 8.19761 6.70499C7.82575 7.07686 7.45495 7.44765 7.08309 7.81952L6.12606 8.77655C5.97184 8.93077 5.81434 9.08389 5.66231 9.2403C5.65575 9.24686 5.65137 9.25014 5.64317 9.2567C5.68965 9.22116 5.73504 9.18561 5.78098 9.15006C5.77551 9.1528 5.77114 9.15444 5.76567 9.15662C5.82036 9.13366 5.87504 9.11014 5.92864 9.08826C5.92318 9.08936 5.91771 9.08936 5.91224 9.091C5.97239 9.0828 6.03364 9.07459 6.0938 9.06639H6.0774C6.13755 9.07459 6.1988 9.0828 6.25896 9.091C6.25349 9.08991 6.24802 9.08826 6.24256 9.08662C6.29724 9.10959 6.35193 9.13311 6.40553 9.15498C6.40006 9.15225 6.39569 9.14951 6.39022 9.14842C6.4367 9.18397 6.48209 9.21951 6.52803 9.25506C6.41209 9.16209 6.31201 9.04179 6.20646 8.93679L4.49524 7.22557C4.37056 7.10088 4.1879 7.02595 4.01126 7.02595C3.84283 7.02595 3.64376 7.09978 3.52728 7.22557C3.40861 7.35572 3.31947 7.52634 3.32767 7.70955C3.33588 7.89111 3.39712 8.06228 3.52728 8.19353C3.87838 8.54462 4.23165 8.89789 4.58276 9.249C4.84799 9.51423 5.11323 9.77947 5.37846 10.0447C5.47799 10.1442 5.57644 10.258 5.69839 10.3302C5.99807 10.5079 6.37761 10.4478 6.62261 10.2099C6.63355 10.2 6.6434 10.1891 6.65379 10.1787C7.02019 9.81228 7.3866 9.44588 7.75301 9.07947C8.31519 8.51728 8.8752 7.95728 9.43735 7.39513C9.77532 7.05715 10.1166 6.72247 10.4518 6.38067C10.4573 6.37521 10.4616 6.37083 10.4671 6.36536C10.5918 6.24067 10.6667 6.05802 10.6667 5.88138C10.6667 5.71295 10.5929 5.51388 10.4671 5.3974C10.337 5.27873 10.1663 5.18959 9.98314 5.19779C9.8065 5.20654 9.63481 5.2667 9.50465 5.39795Z"
                    fill="#0971A2"
                />
                <path
                    d="M6.99973 12.6851C6.73286 12.6851 6.46652 12.6676 6.20238 12.6315C6.26254 12.6397 6.32379 12.6479 6.38395 12.6561C5.86442 12.585 5.35582 12.4472 4.87181 12.2448C4.9265 12.2678 4.98118 12.2913 5.03478 12.3132C4.55626 12.1108 4.1051 11.8483 3.69385 11.5312C3.74033 11.5667 3.78572 11.6023 3.83166 11.6378C3.41877 11.3179 3.04689 10.9476 2.72698 10.5331C2.76253 10.5796 2.79807 10.625 2.83362 10.6709C2.51644 10.2597 2.25394 9.80796 2.05159 9.33C2.07456 9.38468 2.09808 9.43937 2.11995 9.49297C1.91761 9.00899 1.77979 8.5004 1.7087 7.98083C1.71691 8.04099 1.72511 8.10224 1.73331 8.1624C1.66386 7.63303 1.66386 7.09599 1.73331 6.56668C1.72511 6.62683 1.71691 6.68809 1.7087 6.74824C1.7798 6.22872 1.91761 5.72011 2.11995 5.2361C2.09698 5.29079 2.07347 5.34548 2.05159 5.39908C2.25394 4.92056 2.51644 4.46939 2.83362 4.05814C2.79807 4.10463 2.76253 4.15002 2.72698 4.19596C3.04691 3.78307 3.41714 3.41119 3.83166 3.09127C3.78518 3.12682 3.73979 3.16237 3.69385 3.19791C4.1051 2.88073 4.55682 2.61823 5.03478 2.41589C4.9801 2.43886 4.92541 2.46237 4.87181 2.48425C5.35579 2.2819 5.86438 2.14409 6.38395 2.073C6.32379 2.0812 6.26254 2.0894 6.20238 2.09761C6.73175 2.02815 7.26879 2.02815 7.7981 2.09761C7.73795 2.0894 7.6767 2.0812 7.61654 2.073C8.13606 2.14409 8.64467 2.2819 9.12868 2.48425C9.07399 2.46128 9.0193 2.43776 8.9657 2.41589C9.44422 2.61823 9.89539 2.88073 10.3066 3.19791C10.2602 3.16237 10.2148 3.12682 10.1688 3.09127C10.5817 3.4112 10.9536 3.78143 11.2735 4.19596C11.238 4.14947 11.2024 4.10408 11.1669 4.05814C11.4841 4.46939 11.7466 4.92112 11.9489 5.39908C11.9259 5.34439 11.9024 5.2897 11.8805 5.2361C12.0829 5.72008 12.2207 6.22868 12.2918 6.74824C12.2836 6.68809 12.2754 6.62684 12.2672 6.56668C12.3366 7.09605 12.3366 7.63309 12.2672 8.1624C12.2754 8.10224 12.2836 8.04099 12.2918 7.98083C12.2207 8.50036 12.0829 9.00896 11.8805 9.49297C11.9035 9.43829 11.927 9.3836 11.9489 9.33C11.7466 9.80852 11.4841 10.2597 11.1669 10.6709C11.2024 10.6244 11.238 10.5791 11.2735 10.5331C10.9536 10.946 10.5834 11.3179 10.1688 11.6378C10.2153 11.6023 10.2607 11.5667 10.3066 11.5312C9.89539 11.8483 9.44366 12.1108 8.9657 12.3132C9.02039 12.2902 9.07508 12.2667 9.12868 12.2448C8.6447 12.4472 8.13611 12.585 7.61654 12.6561C7.67669 12.6479 7.73794 12.6397 7.7981 12.6315C7.53287 12.667 7.26659 12.6851 6.99973 12.6851C6.82473 12.6851 6.63983 12.7616 6.51569 12.8847C6.39702 13.0033 6.30787 13.1975 6.31608 13.3687C6.32428 13.5447 6.3817 13.7285 6.51569 13.8526C6.64967 13.9757 6.81374 14.0539 6.99967 14.0522C7.68599 14.0512 8.38326 13.9472 9.03681 13.7323C9.67008 13.5245 10.2793 13.2292 10.8224 12.8409C11.1133 12.6331 11.3938 12.4078 11.6525 12.1573C11.9085 11.9096 12.1349 11.6378 12.3525 11.3545C12.76 10.8229 13.0678 10.229 13.2986 9.6017C13.5349 8.95913 13.6585 8.27007 13.6825 7.5864C13.7071 6.9039 13.6213 6.20554 13.4337 5.54772C13.2505 4.90515 12.9678 4.27897 12.5981 3.72114C12.2328 3.17044 11.7942 2.66458 11.2828 2.24456C11.0078 2.01925 10.7207 1.80706 10.4144 1.62386C10.1027 1.43683 9.77566 1.28589 9.43988 1.14808C8.80552 0.888315 8.13175 0.747769 7.44922 0.696907C6.76454 0.644954 6.0629 0.71222 5.39738 0.876275C4.74934 1.03487 4.11661 1.3001 3.54616 1.64737C2.98398 1.9908 2.46226 2.41846 2.02478 2.91173C1.58455 3.40775 1.20721 3.96337 0.933763 4.56877C0.783375 4.90127 0.650487 5.24143 0.553691 5.59307C0.454707 5.95018 0.396191 6.31385 0.354079 6.68189C0.274782 7.36821 0.321266 8.06658 0.459079 8.74367C0.593064 9.39992 0.840803 10.0409 1.16728 10.626C1.48885 11.2002 1.90447 11.7361 2.38135 12.1901C2.85822 12.6451 3.40674 13.0421 3.99905 13.3358C4.60718 13.6376 5.25577 13.8608 5.92839 13.9619C6.28386 14.0155 6.64042 14.0522 7.00026 14.0522C7.17526 14.0522 7.3601 13.9756 7.48424 13.8526C7.60291 13.7339 7.69205 13.5397 7.68385 13.3686C7.67565 13.1925 7.61822 13.0087 7.48424 12.8846C7.34971 12.7632 7.18457 12.6851 6.99973 12.6851Z"
                    fill="#0971A2"
                />
            </g>
        </svg>
    );
};

export const UpICon = () => {
    return (
        <svg
            width="12"
            height="6"
            viewBox="0 0 12 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0.5 5.3666C0.500858 5.58954 0.77554 5.78549 1.17383 5.84734C1.57212 5.90943 1.99874 5.82242 2.22062 5.63409L5.99367 2.31197L9.76671 5.62298C10.0358 5.86001 10.6114 5.93501 11.0521 5.7903C11.4929 5.6456 11.632 5.3361 11.3629 5.09908L6.80224 1.10814C6.62799 0.958348 6.3224 0.867188 5.99364 0.867188C5.66487 0.867188 5.35929 0.958354 5.18504 1.10814L0.645077 5.09908C0.550655 5.17917 0.500429 5.27197 0.5 5.3666Z"
                fill="#333333"
            />
        </svg>
    );
};
export const DownIcon = () => {
    return (
        <svg
            width="12"
            height="6"
            viewBox="0 0 12 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0.5 0.6334C0.500858 0.410457 0.77554 0.214512 1.17383 0.152662C1.57212 0.0905684 1.99874 0.177583 2.22062 0.36591L5.99367 3.68803L9.76671 0.377022C10.0358 0.139989 10.6114 0.0649931 11.0521 0.209701C11.4929 0.354397 11.632 0.663901 11.3629 0.900921L6.80224 4.89186C6.62799 5.04165 6.3224 5.13281 5.99364 5.13281C5.66487 5.13281 5.35929 5.04165 5.18504 4.89186L0.645077 0.900921C0.550655 0.820831 0.500429 0.728031 0.5 0.6334Z"
                fill="#333333"
            />
        </svg>
    );
};
export const BackIcon = ({ width = 13, height = 9.1, fillColor = "rgb(44, 118, 170)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 8 14"
            fill="none">
            <path
                d="M8 1.94296L6.54523 0.5L0 6.99269L0.00737217 7L0 7.00731L6.54523 13.5L8 12.057L2.90153 6.99998L8 1.94296Z"
                fill={fillColor}
            />
        </svg>
    );
};
export const BackIcon1 = ({ width = 13, height = 9.1, fillColor = "rgb(44, 118, 170)" }) => {
    return (
        <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.618717 6.13481L7.29035 0.479538C7.44863 0.345362 7.70785 0.345362 7.86613 0.479538L9.38128 1.76387C9.53957 1.89805 9.53957 2.11777 9.38128 2.25194L4.80052 6.13487C4.64223 6.26905 4.64223 6.48877 4.80052 6.62294L9.38128 10.5059C9.53957 10.64 9.53957 10.8592 9.38128 10.9939L7.86613 12.2783C7.70784 12.4125 7.44863 12.4125 7.29035 12.2783L0.618717 6.623C0.460428 6.48883 0.460428 6.26898 0.618717 6.13481Z" fill="#0971A2" />
        </svg>
    );
};

export const MiniPenIcon = () => {
    return (
        <PenIconStyled
            width="15"
            height="15.5"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.20615 16.1426L0 20.3663L4.22375 19.1602L1.20615 16.1426Z"
                fill="#0971A2"
            />
            <path
                d="M19.9284 3.46349L17.9234 5.46845L14.9365 2.48153L16.9415 0.476562L19.9284 3.46349Z"
                fill="#0971A2"
            />
            <path
                d="M2.125 15.2518L14.0721 3.30469L17.059 6.29161L5.11192 18.2387L2.125 15.2518Z"
                fill="#0971A2"
            />
        </PenIconStyled>
    );
};

export const URLLinkIcon = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.4994 2.90969C13.4994 1.79038 12.5874 0.878906 11.4675 0.878906H9.02922C8.57999 0.878906 8.21647 1.24223 8.21647 1.69122C8.21647 2.14021 8.57999 2.50353 9.02922 2.50353H10.7238L7.13303 6.09234C6.81634 6.40886 6.81634 6.92289 7.13303 7.2418C7.29177 7.40046 7.49893 7.47979 7.70766 7.47979C7.91719 7.47979 8.12436 7.40046 8.2823 7.2418L11.8731 3.653V5.34663C11.8731 5.79562 12.2366 6.15895 12.6858 6.15895C13.135 6.15895 13.4986 5.79562 13.4986 5.34663L13.4994 2.90969Z" fill="#0971A2" />
            <path d="M1.04428 12.4323C1.2824 12.7901 1.5848 13.0899 1.94276 13.3303C2.76346 13.8784 3.90798 13.8784 6.18758 13.8784C8.46718 13.8784 9.61172 13.8784 10.4324 13.3303C10.7904 13.0923 11.0904 12.7901 11.3309 12.4323C11.8508 11.6549 11.8777 10.5824 11.8777 8.59837C11.8777 8.14938 11.5142 7.78606 11.065 7.78606C10.6158 7.78606 10.2522 8.14938 10.2522 8.59837C10.2522 10.1722 10.2316 11.1527 9.9776 11.5326C9.85775 11.7111 9.70774 11.8619 9.52837 11.9816C9.11803 12.2561 8.01477 12.2561 6.18774 12.2561C4.36142 12.2561 3.25573 12.2561 2.84711 11.9816C2.66853 11.8619 2.51773 11.7119 2.39788 11.5326C2.12325 11.1225 2.12325 10.0199 2.12325 8.19384C2.12325 6.36851 2.12325 5.26341 2.39788 4.85502C2.51773 4.67654 2.66774 4.52581 2.84711 4.40604C3.2273 4.15219 4.20832 4.13395 5.78299 4.13156C6.23222 4.13156 6.59574 3.76823 6.59574 3.31924C6.59574 2.87026 6.23222 2.50693 5.78299 2.50693C3.79794 2.50693 2.7248 2.53311 1.94455 3.05508C1.58897 3.29307 1.28656 3.59531 1.04845 3.95069C0.5 4.77095 0.5 5.91485 0.5 8.19321C0.5 10.4716 0.5 11.6155 1.04845 12.4357L1.04428 12.4323Z" fill="#0971A2" />
        </svg>
    );
};